/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */

import { useI18nBundle } from '@ui5/webcomponents-react-base';

type I18nText = {
    key: string;
    defaultText: string;
};

export type TranslationFn = (key: string | I18nText | undefined, ...params: string[]) => string;

export const useTranslations = (bundleName: string = 'myApp'): { t: TranslationFn } => {
    const i18nBundle = useI18nBundle(bundleName);
    const fallBackBundle = useI18nBundle('i18n');

    const t = (key: string | I18nText | undefined, ...params: string[]) => {
        if (!key) {
            return '';
        }
        let text = i18nBundle.getText(key, ...params);
        if (text === key) {
            text = fallBackBundle.getText(key, ...params);
        }
        return text;
    };

    return { t };
};
